import React, { useContext } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Button } from "@mui/material";
import { StateManagerContext } from "./StateManagerContext";
import { ActionButton, ActionHandler, CreateAction, EmptyActionData } from "./ActionButton";
import { FanboxStyling } from "./CSSUtilities";

export type CheckoutFormProps = {
    clientSecret: string;
    onError: () => void;


};

export const CheckoutForm = ({ clientSecret, onError }: CheckoutFormProps): JSX.Element => {

    const [errorState, setErrorState] = React.useState<boolean>(false);
    const stripe = useStripe();
    const elements = useElements();

    const stateManager = useContext(StateManagerContext);

    const makePayment = async () => {
        if (!stripe || !elements)
            return;

        const storedPayment = { token: clientSecret, userId: stateManager.user().fanbox.id };

        sessionStorage.setItem('Fanbox.StoredPayment', JSON.stringify(storedPayment));

        const response = await fetch("/api/payments/confirmPayment", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ userId: stateManager.user().fanbox.id, accessToken: stateManager.user().fanbox.accessToken, paymentIntent: clientSecret }),
        });
        const root = await response.json();

        if (root.confirm === true) {

            const { error } = await stripe.confirmPayment({
                confirmParams: {
                    return_url: 'http://localhost:3000/'
                },
                elements: elements
            });
        }
        else {
            setErrorState(true);
        }

    }

    if (errorState) {
        const handler: ActionHandler = (_action) => { onError(); setErrorState(false); return true; }
        const action = CreateAction('onClick', [], handler);

        const buttonStyling: FanboxStyling = {
            width: 180,
            height: 48,
            color: {
                foreground: 'black',
                background: 'green'
            },
            font: {
                size: 18,
                weight: 'regular'
            },
            boundary: {
                radius: 25
            }
        }



        return <div>
            <span>We apologize, something has gone wrong with your payment journey. You will need to restart the purchase. Do not worry, no payment has been taken. </span>
            <ActionButton text={'Restart'} action={action} actionData={EmptyActionData} styling={buttonStyling} prompt={'left'} />
        </div>
    }
    else {

        return (
            <div>
                <PaymentElement />
                <Button onClick={() => { makePayment(); }}
                    sx={{
                        borderRadius: '25px',
                        width: '92px',
                        minWidth: '92px',
                        maxWidth: '92px',
                        height: '48px',
                        minHeight: '48px',
                        maxHeight: '48px',
                        color: 'black',
                        fontSize: '18px',
                        fontWeight: 400,
                        backgroundColor: '#92CA36'
                    }} >Pay</Button>
            </div>

        );
    }

}